import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import QrReader from './QrReader';
import QrCodeIcon from '@mui/icons-material/QrCode';
import axios from "axios";
import config from "../../utils/config";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

function CheckIn({ setTitle, organization }) {
    const navigate = useNavigate();

    const [readerOpen, setReaderOpen] = useState(false);
    const [purchase, setPurchase] = useState(null);

    useEffect(() => {
        setTitle("Check-in");
    }, []); // eslint-disable-line

    const handleScan = (result) => {
        let text = result.data;

        axios.post(`${config.API_ENDPOINT}/event-purchases/${organization}/${text}/checkin`, {}, { headers: { "x-access-token": localStorage.getItem("access-token") } })
            .then(res => {
                setPurchase(res.data);
                toast.success("Ticket checked-in successfully!");
            })
            .catch(err => {
                switch (err.response?.status) {
                    case 401:
                        localStorage.removeItem("access-token");
                        window.location.replace("/login");
                        break;
                    case 404:
                        toast.error("Invalid QR Code");
                        break;
                    case 409:
                        toast.warn("Ticket already checked-in!");
                        setPurchase(err.response.data);
                        break;
                    default:
                        toast.error("An unexpected error has occurred");
                        break;
                }
            });
    };

    const getContent = () => {
        if (purchase == null) {
            return <Typography variant="body2" sx={{ color: "text.secondary" }}>Open the scanner to start</Typography>
        }

        return <Box>
            <Typography variant="body2">
                <strong>Event:</strong> {purchase.eventName}
            </Typography>
            <Typography variant="body2">
                <strong>Name:</strong> {purchase.name}
            </Typography>
            {purchase.esnCard ? (
                <Typography variant="body2">
                    <strong>ESNcard:</strong> {purchase.esnCard}
                </Typography>
            ) : null}
            <Typography variant="body2">
                <strong>ID/Passport:</strong> {purchase.passport}
            </Typography>
            <Typography variant="body2">
                <strong>Checked-in at: </strong> {moment(purchase.checkedInAt).format("DD/MM/YYYY HH:mm")}
            </Typography>
            <Typography variant="body2">
                <strong>Checked-in by: </strong> {purchase.checkedInBy?.name}
            </Typography>
            <Button sx={{ mt: 3 }} variant="outlined" onClick={() => navigate(`/event-purchase-details/${purchase._id}`)}>
                View Details
            </Button>
        </Box>;
    }

    return (
        <Container sx={{ textAlign: "center" }}>
            <Box sx={{ mb: 4, pb: 3, borderBottom: "1px solid rgba(19, 33, 68, 0.1)" }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>Check-in</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Scan participant tickets and review the latest check-in result
                </Typography>
            </Box>

            <Card sx={{ maxWidth: 620, mx: "auto" }}>
                <CardContent>
                    {getContent()}
                    <Button sx={{ mt: 3 }} variant="contained" startIcon={<QrCodeIcon />} onClick={() => setReaderOpen(true)}>Open Scanner</Button>
                </CardContent>
            </Card>

            <QrReader open={readerOpen} onClose={() => setReaderOpen(false)} onResult={handleScan} />
        </Container>
    )
}

export default CheckIn;